import React from "react";
import PropTypes from "prop-types";
import { toOrbitShortName, calculateOrbitType } from "./orbit";
import styled from "styled-components";

const Wrapper = styled.span`
	font-size: 0.9em;
	font-weight: bold;
	color: ${(props) =>
		props.regimeShort === "LEO"
			? "#ccffb5"
			: props.regimeShort === "MEO"
				? "#b5fdff"
				: props.regimeShort === "GEO"
					? "#c2b5ff"
					: "white"};
`;
/**
 * Renders the orbital regime of a given RSO in a short manner for display.
 */
const RSOOrbitRegimeShort = ({ periapsis, apoapsis, period }) => {
	const regime = calculateOrbitType(periapsis, apoapsis, period);
	const regimeShort = toOrbitShortName(regime);
	return (
		<Wrapper title={regime} regimeShort={regimeShort}>
			{regimeShort}
		</Wrapper>
	);
};

RSOOrbitRegimeShort.propTypes = {
	periapsis: PropTypes.number,
	apoapsis: PropTypes.number,
	period: PropTypes.number,
};

export default RSOOrbitRegimeShort;
